import axios from 'axios';

const { REACT_APP_AI_HOST } = process.env;

const SingleKeyNarrativeLoadAPI = stock_code => {
	return axios.get(
		`${REACT_APP_AI_HOST}/api/assist/reports?stock=${stock_code}`,
        //https://data.uanalyze.twobitto.com/api/assist/reports?stock=2330
		{
			headers: {
				Accept: 'application/json',
			},
		}
	);
};

export default { SingleKeyNarrativeLoadAPI };
